<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Admin</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de tipos de
                                usuário</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click="EditNew()">Incluir Novo</a> </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="TipoUsuario.tusId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="TipoUsuario.tusNome"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Visivel</label>
                                            <select v-model="TipoUsuario.tusVisivel" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="TipoUsuario.tusAtivo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoPessoas != ''">
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select  v-model="TipoUsuario.tpeId" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.tpeId"
                                                    :value="optionTipo.tpeId">{{ optionTipo.tpeNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoUsuario.tpeId == 1">
                                        <div class="form-group">
                                            <label>Garantidoras</label>
                                            <select class="form-select form-control" id="defaultSelect">
                                                <option value="">Selecione</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action">
                        <button v-if="TipoUsuario.tusId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()"  class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de tipos de usuário</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="TipoPessoas!=''">
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="TipoUsuarios" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                    <template #item-tusVisivel="item">
                                        <span>{{ item.tusVisivel ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tusAtivo="item">
                                        <span>{{ item.tusAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tpeId="item">
                                        <span>{{ item.tpeId != null ? TipoPessoas.filter(x=> x.tpeId == item.tpeId)[0].tpeNome : 'GarantePay' }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>

                                        <v-btn icon @click="DeleteGrid(item)" variant="text">
                                            <v-icon class="deliconcor">mdi-delete-forever</v-icon>
                                            <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroTipoUsuarioView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        TipoUsuario: {
            tusId: 0,
            tusNome: '',
            tusVisivel: '',
            tusAtivo: '',
            tpeId: '',
        },
        TipoUsuarios: [],
        selectedVisivel: null,
        headers: [
            { text: "Id", value: "tusId", sortable: true, },
            { text: "Nome", value: "tusNome", sortable: true, },
            { text: "Visivel", value: "tusVisivel", sortable: true, },
            { text: "Ativo", value: "tusAtivo", sortable: true, },
            { text: "Tipo", value: "tpeId", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        TipoPessoas:[],
    }),
    methods: {
          //edit
          EditNew(){
            this.EditView = true;
            this.TipoUsuario.tusId = 0;
            this.TipoUsuario.tusNome= '';
            this.TipoUsuario.tusVisivel= '';
            this.TipoUsuario.tusAtivo= '';
            this.TipoUsuario.tpeId= '';
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.tusId != ''){
            axios.get(`/Telas/TipoUsuario/GetById/` + item.tusId)
                .then(response => {
                    this.TipoUsuario = response.data;
                });
            }
        },
        Add() {
            if (this.TipoUsuario.tusNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoUsuario.tusVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoUsuario.tusAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                if (this.TipoUsuario.tpeId === "") {
                        this.TipoUsuario.tpeId = null;
                    }
                    
                axios.post(`/Telas/TipoUsuario/Add`, this.TipoUsuario)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        Put() {
            if (this.TipoUsuario.tusNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoUsuario.tusVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoUsuario.tusAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                if (this.TipoUsuario.tpeId === "") {
                        this.TipoUsuario.tpeId = null;
                    }


                axios.put(`/Telas/TipoUsuario/Update`, this.TipoUsuario)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        EditCancel(){
            //window.location.reload();
            this.$router.go(0);
        },
          //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.tusId;
                axios.delete(`/Telas/TipoUsuario/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                    }
                });
            }
            });
        },
        async Get() {
            this.EditView = false;
            await axios.get(`/Telas/TipoUsuario/GetDados`)
               .then(response => {
                this.TipoUsuarios = response.data.tipoUsuarios;
                 this.TipoPessoas = response.data.tiposPessoas;
           });
            
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
